// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_of-0";
export var buttonContainer = "_of-3";
export var cancelButton = "_of-4";
export var headerSection = "_of-6";
export var headerTitle = "_of-9";
export var messageSideLeft = "_of-1";
export var messageSideRight = "_of-2";
export var orderNumberContainer = "_of-7";
export var orderNumberLabel = "_of-8";
export var submitButton = "_of-5";